import * as atomSkeletons from './AtomSkeletons'
import * as typeSkeletons from './TypeSkeletons'
import * as compoundSkeletons from './CompoundSkeletons'
import * as inputSkeletons from './InputSkeletons'
import BaseSkeleton from './BaseSkeleton'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Because multiple skeletons are not typed yet, we need to cast here, and we just allow any for the non-typed ones.
type SkeletonType = typeof typeSkeletons & Record<string, any>
const Skeleton: SkeletonType = {
  ...inputSkeletons,
  ...atomSkeletons,
  ...typeSkeletons,
  ...compoundSkeletons,
  Base: BaseSkeleton,
}

export default Skeleton
